<div class="tili-num"></div>
<div class="long-col">{{ label }}</div>
<div class="short-col"></div>
<div class="end-marking"></div>
